<script>
import Swal from 'sweetalert2';

export default {
    props: {
        eventoId: {
            type: [Number, String],
            default: null,
        },
        eventoNombre: {
            type: String,
            default: '',
        },
        user: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            asistentes: [],
            cargando: false,
            descargandoListadoQr: false,
            enviandoQrCrm: false,
            filtroCrm: 'todos',
            pollingCrmTimer: null,
            iniciandoScanner: false,
            scannerActivo: false,
            scannerInstancia: null,
            scannerClase: null,
            currentScan: null,
            guardandoAsistencia: false,
            errorScanner: '',
            ultimoTextoLeido: '',
            ultimaLecturaAt: 0,
            procesandoLectura: false,
            desktopQrValue: '',
            eliminandoAsistenteId: null,
            resumenAsistentes: {
                total: 0,
                totalFiltrado: 0,
                confirmados: 0,
                pendientes: 0,
                crmEnviados: 0,
                crmPendientes: 0,
                crmProgramados: 0,
                crmEnProceso: 0,
                crmErrores: 0,
            },
            paginacion: {
                page: 1,
                perPage: 80,
                totalPages: 1,
                from: 0,
                to: 0,
                hasPrev: false,
                hasNext: false,
            },
            metricasRespuesta: null,
            publicScanLink: '',
            cargandoPublicScanLink: false,
            copiandoPublicScanLink: false,
            linkEscaneoIntentado: false,
            publicScanLinkVigente: false,
            publicScanLinkCerrado: false,
            publicScanLinkExpiraEn: '',
            qrGeneratorLink: `${window.location.origin}/qreventos`,
        };
    },
    computed: {
        readerId() {
            return `qr-reader-evento-${this._uid}`;
        },
        asistentesConfirmados() {
            if (this.resumenAsistentes && Number.isFinite(Number(this.resumenAsistentes.confirmados))) {
                return Number(this.resumenAsistentes.confirmados);
            }

            return this.asistentes.filter((item) => !!item.asistio).length;
        },
        asistentesPendientes() {
            if (this.resumenAsistentes && Number.isFinite(Number(this.resumenAsistentes.pendientes))) {
                return Number(this.resumenAsistentes.pendientes);
            }

            return this.asistentes.filter((item) => !item.asistio).length;
        },
        scanButtonLabel() {
            if (this.iniciandoScanner) {
                return 'Abriendo cámara...';
            }

            return this.scannerActivo ? 'Detener escáner' : 'Escanear QR';
        },
        puedeVerMetricasFila() {
            const userId = Number(this.user && this.user.id ? this.user.id : 0);
            const rol = (this.user && this.user.rol ? this.user.rol : '').toString().toLowerCase().trim();

            return userId === 1 || rol === 'superadmin';
        },
        puedeGestionarCrm() {
            const userId = Number(this.user && this.user.id ? this.user.id : 0);
            const rol = (this.user && this.user.rol ? this.user.rol : '').toString().toLowerCase().trim();

            return userId === 1 || ['supervisor', 'admin', 'superadmin'].includes(rol);
        },
        totalProgramableCrm() {
            return Number(this.resumenAsistentes.crmPendientes || 0) + Number(this.resumenAsistentes.crmErrores || 0);
        },
        crmProcesados() {
            return Number(this.resumenAsistentes.crmEnviados || 0) + Number(this.resumenAsistentes.crmErrores || 0);
        },
        crmProgreso() {
            const total = Number(this.resumenAsistentes.total || 0);
            return total > 0 ? Math.min(100, Math.round((this.crmProcesados / total) * 100)) : 0;
        },
    },
    watch: {
        eventoId: {
            immediate: true,
            handler() {
                this.resetScannerState();
                this.filtroCrm = 'todos';
                this.cargarAsistentes();
                this.publicScanLink = '';
                this.linkEscaneoIntentado = false;
                this.publicScanLinkVigente = false;
                this.publicScanLinkCerrado = false;
                this.publicScanLinkExpiraEn = '';
                this.consultarLinkEscaneoPublico({ silent: true });
            },
        },
    },
    beforeDestroy() {
        this.detenerScanner();
        this.detenerPollingCrm();
    },
    methods: {
        async cargarAsistentes(options = {}) {
            const keepPage = !!options.keepPage;
            const silent = !!options.silent;

            if (!this.eventoId) {
                this.asistentes = [];
                this.resumenAsistentes = {
                    total: 0,
                    totalFiltrado: 0,
                    confirmados: 0,
                    pendientes: 0,
                    crmEnviados: 0,
                    crmPendientes: 0,
                    crmProgramados: 0,
                    crmEnProceso: 0,
                    crmErrores: 0,
                };
                this.detenerPollingCrm();
                this.paginacion = {
                    page: 1,
                    perPage: this.paginacion?.perPage || 80,
                    totalPages: 1,
                    from: 0,
                    to: 0,
                    hasPrev: false,
                    hasNext: false,
                };
                return;
            }

            if (!keepPage) {
                this.paginacion.page = 1;
            }

            if (!silent) {
                this.cargando = true;
            }
            try {
                const res = await axios.get(`/api/get_asistentes_qr_evento/${this.eventoId}`, {
                    params: {
                        page: this.paginacion.page,
                        per_page: this.paginacion.perPage,
                        filtro_crm: this.puedeGestionarCrm ? this.filtroCrm : 'todos',
                    },
                });
                this.asistentes = (res.data && Array.isArray(res.data.asistentes)) ? res.data.asistentes : [];
                this.actualizarResumenAsistentes(res.data || {});
            } catch (error) {
                this.asistentes = [];
                this.detenerPollingCrm();
                this.paginacion.totalPages = 1;
                this.paginacion.from = 0;
                this.paginacion.to = 0;
                this.paginacion.hasPrev = false;
                this.paginacion.hasNext = false;
                this.errorScanner = error?.response?.data?.mensaje || 'No se pudo cargar la lista de asistentes QR.';
            } finally {
                if (!silent) {
                    this.cargando = false;
                }
            }
        },
        async consultarLinkEscaneoPublico(options = {}) {
            return this.cargarLinkEscaneoPublico({ ...options, generate: false });
        },
        async generarLinkEscaneoPublico() {
            return this.cargarLinkEscaneoPublico({ generate: true });
        },
        async cargarLinkEscaneoPublico(options = {}) {
            const silent = !!options.silent;
            const generate = !!options.generate;

            if (!this.eventoId) {
                if (!silent) {
                    this.notify('warning', 'Selecciona un evento antes de generar el link público.');
                }
                return;
            }

            this.cargandoPublicScanLink = true;
            try {
                const res = await axios.get(`/api/qreventos/eventos/${this.eventoId}/link-escaneo`, {
                    params: { generate: generate ? 1 : 0 },
                });
                if (!res.data || !res.data.estado) {
                    throw new Error((res.data && res.data.mensaje) || 'No se pudo obtener el link público.');
                }

                this.publicScanLink = res.data.link || '';
                this.publicScanLinkVigente = !!res.data.vigente;
                this.publicScanLinkCerrado = !!res.data.cerrada;
                this.publicScanLinkExpiraEn = res.data.expira_en || '';
                if (generate && this.publicScanLink) {
                    this.notify('success', 'Link de escaneo público generado.');
                }
            } catch (error) {
                if (!silent) {
                    this.notify('error', error?.response?.data?.mensaje || error?.message || 'No se pudo obtener el link público.');
                }
            } finally {
                this.cargandoPublicScanLink = false;
                this.linkEscaneoIntentado = true;
            }
        },
        async copiarLinkEscaneoPublico() {
            if (!this.publicScanLink) {
                await this.consultarLinkEscaneoPublico();
            }

            if (!this.publicScanLink) {
                return;
            }

            this.copiandoPublicScanLink = true;
            try {
                await navigator.clipboard.writeText(this.publicScanLink);
                this.notify('success', 'Link de escaneo público copiado.');
            } catch (error) {
                this.notify('error', 'No se pudo copiar el link público.');
            } finally {
                this.copiandoPublicScanLink = false;
            }
        },
        async toggleScanner() {
            if (this.scannerActivo || this.iniciandoScanner) {
                await this.detenerScanner();
                return;
            }

            await this.iniciarScanner();
        },
        async ensureScannerClass() {
            if (this.scannerClase) {
                return this.scannerClase;
            }

            const mod = await import('html5-qrcode');
            this.scannerClase = mod.Html5Qrcode;
            return this.scannerClase;
        },
        async iniciarScanner() {
            if (!this.eventoId) {
                this.notify('warning', 'Selecciona un evento antes de usar el escáner QR.');
                return;
            }

            this.iniciandoScanner = true;
            this.errorScanner = '';

            try {
                const Html5Qrcode = await this.ensureScannerClass();
                const isMobile = window.innerWidth < 768;
                const qrBoxSize = isMobile
                    ? Math.max(180, Math.min(window.innerWidth - 96, 240))
                    : 220;
                if (!this.scannerInstancia) {
                    this.scannerInstancia = new Html5Qrcode(this.readerId);
                }

                await this.scannerInstancia.start(
                    { facingMode: 'environment' },
                    {
                        fps: 10,
                        qrbox: { width: qrBoxSize, height: qrBoxSize },
                        ...(isMobile ? {} : { aspectRatio: 1 }),
                    },
                    async (decodedText) => {
                        await this.handleDecodedText(decodedText);
                    },
                    () => {}
                );

                this.scannerActivo = true;
            } catch (error) {
                console.error('No se pudo iniciar el escáner QR', error);
                this.errorScanner = 'No fue posible abrir la cámara. Revisa permisos del navegador e intenta nuevamente.';
            } finally {
                this.iniciandoScanner = false;
            }
        },
        async detenerScanner() {
            this.errorScanner = '';

            if (!this.scannerInstancia) {
                this.scannerActivo = false;
                return;
            }

            try {
                await this.scannerInstancia.stop();
                await this.scannerInstancia.clear();
            } catch (error) {
                // Ignorar errores cuando el scanner ya fue detenido internamente.
            } finally {
                this.scannerInstancia = null;
                this.scannerActivo = false;
            }
        },
        async pausarScanner() {
            if (!this.scannerInstancia || typeof this.scannerInstancia.pause !== 'function') {
                return;
            }

            try {
                this.scannerInstancia.pause(true);
            } catch (error) {
                console.warn('No se pudo pausar el escáner', error);
            }
        },
        async reanudarScanner() {
            if (!this.scannerInstancia || typeof this.scannerInstancia.resume !== 'function') {
                return;
            }

            try {
                this.scannerInstancia.resume();
            } catch (error) {
                console.warn('No se pudo reanudar el escáner', error);
            }
        },
        async handleDecodedText(decodedText) {
            const ahora = Date.now();
            const inicioFlujo = performance.now();
            if (this.procesandoLectura || this.guardandoAsistencia || this.currentScan) {
                return;
            }

            if (decodedText === this.ultimoTextoLeido && ahora - this.ultimaLecturaAt < 1800) {
                return;
            }

            this.procesandoLectura = true;
            this.ultimoTextoLeido = decodedText;
            this.ultimaLecturaAt = ahora;

            try {
                const payload = this.parseQrPayload(decodedText);
                await this.pausarScanner();
                await this.registrarLectura(payload, inicioFlujo);
            } catch (error) {
                this.errorScanner = error?.message || 'El QR leído no corresponde a una credencial válida.';
                await this.reanudarScanner();
            } finally {
                this.procesandoLectura = false;
            }
        },
        parseQrPayload(decodedText) {
            const text = String(decodedText || '').trim();
            if (!text) {
                throw new Error('El QR está vacío.');
            }

            if (text.startsWith('{')) {
                return JSON.parse(text);
            }

            const url = new URL(text, window.location.origin);
            const encodedPayload = url.searchParams.get('p');
            if (!encodedPayload) {
                throw new Error('El QR no contiene datos reconocibles del formulario.');
            }

            const normalized = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
            const padded = normalized + '='.repeat((4 - (normalized.length % 4 || 4)) % 4);
            const decoded = decodeURIComponent(escape(window.atob(padded)));
            const payload = JSON.parse(decoded);

            if (!payload.documento || !payload.nombres) {
                throw new Error('El QR no contiene los campos mínimos para registrar asistencia.');
            }

            return payload;
        },
        async registrarLectura(payload, inicioFlujo = null) {
            try {
                const inicioRegistro = performance.now();
                const res = await axios.post('/api/registrar_asistente_qr', {
                    evento_id: Number(this.eventoId),
                    tipo_documento: payload.tipo_documento || 'rut',
                    documento: payload.documento || '',
                    nombres: payload.nombres || '',
                    apellido_paterno: payload.apellido_paterno || '',
                    apellido_materno: payload.apellido_materno || '',
                    email: payload.email || '',
                    celular: payload.celular || '',
                    payload_qr: payload,
                });
                const finRegistro = performance.now();
                const msRegistro = Math.round(finRegistro - inicioRegistro);

                if (!res.data || !res.data.estado || !res.data.asistente) {
                    throw new Error((res.data && res.data.mensaje) || 'No se pudo registrar el QR leído.');
                }

                const asistente = res.data.asistente;
                this.currentScan = asistente;
                this.mergeAsistente(asistente);

                if (res.data.ya_asistio || asistente.asistio) {
                    this.notify('info', res.data.mensaje || 'La asistencia ya estaba confirmada.');
                    this.setMetricasRespuesta(msRegistro, 0, inicioFlujo, true, 'ya-confirmado');
                    this.currentScan = null;
                    await this.reanudarScanner();
                    return;
                }

                const inicioConfirmacion = performance.now();
                const confirmadoOk = await this.confirmarAsistencia(asistente);
                const finConfirmacion = performance.now();
                const msConfirmacion = Math.round(finConfirmacion - inicioConfirmacion);
                this.setMetricasRespuesta(msRegistro, msConfirmacion, inicioFlujo, !!confirmadoOk, 'confirmado');
            } catch (error) {
                this.errorScanner = error?.response?.data?.mensaje || error?.message || 'No se pudo registrar el QR leído.';
                this.setMetricasRespuesta(0, 0, inicioFlujo, false, 'error');
                await this.reanudarScanner();
            }
        },
        async probarQrManual() {
            const rawValue = String(this.desktopQrValue || '').trim();
            if (!rawValue) {
                this.notify('warning', 'Pega primero el enlace del QR o su contenido para probarlo.');
                return;
            }

            this.errorScanner = '';

            try {
                const payload = this.parseQrPayload(rawValue);
                await this.registrarLectura(payload);
            } catch (error) {
                this.errorScanner = error?.message || 'No se pudo interpretar el contenido pegado.';
            }
        },
        async confirmarAsistencia(item = null) {
            const asistente = item || this.currentScan;
            if (!asistente || !asistente.id) {
                return false;
            }

            this.guardandoAsistencia = true;

            try {
                const res = await axios.post('/api/confirmar_asistencia_qr', {
                    id: asistente.id,
                    evento_id: Number(this.eventoId),
                });

                if (!res.data || !res.data.estado || !res.data.asistente) {
                    throw new Error((res.data && res.data.mensaje) || 'No se pudo confirmar la asistencia.');
                }

                this.mergeAsistente(res.data.asistente);
                this.currentScan = null;
                this.notify('success', res.data.mensaje || 'Asistencia confirmada.');
                await this.reanudarScanner();
                return true;
            } catch (error) {
                this.notify('error', error?.response?.data?.mensaje || error?.message || 'No se pudo confirmar la asistencia.');
                return false;
            } finally {
                this.guardandoAsistencia = false;
            }
        },
        setMetricasRespuesta(msRegistro, msConfirmacion, inicioFlujo, ok, estado) {
            const total = Number.isFinite(Number(inicioFlujo))
                ? Math.max(0, Math.round(performance.now() - Number(inicioFlujo)))
                : Math.max(0, Number(msRegistro || 0) + Number(msConfirmacion || 0));

            this.metricasRespuesta = {
                msRegistro: Number(msRegistro || 0),
                msConfirmacion: Number(msConfirmacion || 0),
                msTotal: total,
                ok: !!ok,
                estado: estado || 'desconocido',
                at: new Date().toISOString(),
            };
        },
        async eliminarAsistente(item) {
            if (!item || !item.id) {
                return;
            }

            const confirmacion = await Swal.fire({
                title: 'Descartar registro QR',
                text: `Se descartará el registro de ${this.nombreCompleto(item)}. Si se escanea de nuevo, se reactiva automáticamente.`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Descartar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#f0ad4e',
            });

            if (!confirmacion.isConfirmed) {
                return;
            }

            this.eliminandoAsistenteId = Number(item.id);

            try {
                const res = await axios.post('/api/eliminar_asistente_qr', {
                    id: Number(item.id),
                    evento_id: Number(this.eventoId),
                });

                if (!res.data || !res.data.estado) {
                    throw new Error((res.data && res.data.mensaje) || 'No se pudo eliminar el registro QR.');
                }

                this.asistentes = (this.asistentes || []).filter((asistente) => Number(asistente.id) !== Number(item.id));
                this.ajustarResumenPorEliminacion(item);
                if (this.currentScan && Number(this.currentScan.id) === Number(item.id)) {
                    this.currentScan = null;
                }
                this.notify('success', res.data.mensaje || 'Registro QR descartado correctamente.');
            } catch (error) {
                this.notify('error', error?.response?.data?.mensaje || error?.message || 'No se pudo descartar el registro QR.');
            } finally {
                this.eliminandoAsistenteId = null;
            }
        },
        async escanearSiguiente() {
            this.currentScan = null;
            await this.reanudarScanner();
        },
        mergeAsistente(asistente) {
            const items = Array.isArray(this.asistentes) ? [...this.asistentes] : [];
            const idx = items.findIndex((item) => Number(item.id) === Number(asistente.id));
            const previo = idx >= 0 ? items[idx] : null;

            if (idx >= 0) {
                items.splice(idx, 1, asistente);
            } else {
                items.unshift(asistente);
            }

            items.sort((a, b) => {
                const left = new Date(a.asistio_at || a.escaneado_at || 0).getTime();
                const right = new Date(b.asistio_at || b.escaneado_at || 0).getTime();
                return right - left;
            });

            this.asistentes = items;
            this.ajustarResumenPorMerge(previo, asistente);
        },
        actualizarResumenAsistentes(data) {
            this.resumenAsistentes = {
                total: Number(data.total_general || data.total || 0),
                totalFiltrado: Number(data.total || 0),
                confirmados: Number(data.confirmados || 0),
                pendientes: Number(data.pendientes || 0),
                crmEnviados: Number(data.crm_enviados || 0),
                crmPendientes: Number(data.crm_pendientes || 0),
                crmProgramados: Number(data.crm_programados || 0),
                crmEnProceso: Number(data.crm_en_proceso || 0),
                crmErrores: Number(data.crm_errores || 0),
            };

            const totalPages = Number(data.total_pages || 1);
            this.paginacion = {
                ...this.paginacion,
                page: Number(data.page || this.paginacion.page || 1),
                perPage: Number(data.per_page || this.paginacion.perPage || 80),
                totalPages: Number.isFinite(totalPages) && totalPages > 0 ? totalPages : 1,
                from: Number(data.from || 0),
                to: Number(data.to || 0),
                hasPrev: !!data.has_prev,
                hasNext: !!data.has_next,
            };

            this.actualizarPollingCrm();
        },
        async irPagina(page) {
            const destino = Number(page || 1);
            const totalPages = Number(this.paginacion.totalPages || 1);
            if (!Number.isFinite(destino) || destino < 1 || destino > totalPages || destino === this.paginacion.page) {
                return;
            }

            this.paginacion.page = destino;
            await this.cargarAsistentes({ keepPage: true });
        },
        async cambiarTamanoPagina() {
            this.paginacion.page = 1;
            await this.cargarAsistentes({ keepPage: true });
        },
        async cambiarFiltroCrm() {
            this.paginacion.page = 1;
            await this.cargarAsistentes({ keepPage: true });
        },
        actualizarPollingCrm() {
            if (!this.puedeGestionarCrm) {
                this.detenerPollingCrm();
                return;
            }

            const activo = Number(this.resumenAsistentes.crmProgramados || 0) > 0
                || Number(this.resumenAsistentes.crmEnProceso || 0) > 0;

            if (activo && !this.pollingCrmTimer) {
                this.pollingCrmTimer = window.setInterval(() => {
                    this.cargarAsistentes({ keepPage: true, silent: true });
                }, 5000);
            } else if (!activo) {
                this.detenerPollingCrm();
            }
        },
        detenerPollingCrm() {
            if (this.pollingCrmTimer) {
                window.clearInterval(this.pollingCrmTimer);
                this.pollingCrmTimer = null;
            }
        },
        async enviarAsistentesQrCrm() {
            if (!this.puedeGestionarCrm || !this.eventoId || this.totalProgramableCrm === 0) {
                return;
            }

            const result = await Swal.fire({
                icon: 'warning',
                title: 'Enviar asistentes QR al CRM',
                text: `Se agregarán ${this.totalProgramableCrm} registros pendientes o con error a la cola CRM.`,
                showCancelButton: true,
                confirmButtonText: 'Agregar a la cola',
                cancelButtonText: 'Cancelar',
            });

            if (!result.isConfirmed) {
                return;
            }

            this.enviandoQrCrm = true;
            try {
                const res = await axios.post('/api/enviar_asistentes_qr_crm', {
                    id: this.eventoId,
                });

                if (!res.data || !res.data.estado) {
                    throw new Error((res.data && res.data.mensaje) || 'No se pudo programar el envío CRM.');
                }

                this.notify('success', res.data.mensaje || 'Asistentes QR agregados a la cola CRM.');
                await this.detenerScanner();
                await Promise.all([
                    this.cargarAsistentes({ keepPage: true, silent: true }),
                    this.consultarLinkEscaneoPublico({ silent: true }),
                ]);
            } catch (error) {
                this.notify('error', error?.response?.data?.mensaje || error?.message || 'No se pudo programar el envío CRM.');
            } finally {
                this.enviandoQrCrm = false;
            }
        },
        ajustarResumenPorMerge(previo, actual) {
            const resumen = this.resumenAsistentes || { total: 0, confirmados: 0, pendientes: 0 };
            let total = Number(resumen.total || 0);
            let confirmados = Number(resumen.confirmados || 0);
            let pendientes = Number(resumen.pendientes || 0);

            if (!previo) {
                total += 1;
                if (actual && actual.asistio) {
                    confirmados += 1;
                } else {
                    pendientes += 1;
                }
            } else if (!previo.asistio && actual && actual.asistio) {
                confirmados += 1;
                pendientes = Math.max(pendientes - 1, 0);
            } else if (previo.asistio && actual && !actual.asistio) {
                confirmados = Math.max(confirmados - 1, 0);
                pendientes += 1;
            }

            this.resumenAsistentes = { ...resumen, total, totalFiltrado: total, confirmados, pendientes };
        },
        ajustarResumenPorEliminacion(item) {
            const resumen = this.resumenAsistentes || { total: 0, confirmados: 0, pendientes: 0 };
            const total = Math.max(Number(resumen.total || 0) - 1, 0);
            const confirmados = item && item.asistio
                ? Math.max(Number(resumen.confirmados || 0) - 1, 0)
                : Number(resumen.confirmados || 0);
            const pendientes = item && item.asistio
                ? Number(resumen.pendientes || 0)
                : Math.max(Number(resumen.pendientes || 0) - 1, 0);

            this.resumenAsistentes = { ...resumen, total, totalFiltrado: total, confirmados, pendientes };
        },
        resetScannerState() {
            this.currentScan = null;
            this.errorScanner = '';
            this.ultimoTextoLeido = '';
            this.ultimaLecturaAt = 0;
            this.procesandoLectura = false;
            this.paginacion.page = 1;
            this.detenerScanner();
        },
        nombreCompleto(item) {
            return item?.nombre || [item?.nombres, item?.apellido_paterno, item?.apellido_materno].filter(Boolean).join(' ') || '-';
        },
        formatFecha(fecha) {
            if (!fecha) {
                return '-';
            }

            try {
                return new Date(fecha).toLocaleString('es-CL', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                });
            } catch (error) {
                return fecha;
            }
        },
        formatFechaExpiracionLink(fecha) {
            return this.formatFecha(fecha);
        },
        formatRespuestaQr(item) {
            const estado = String(item?.respuesta_qr || '').trim().toLowerCase();

            if (!estado) {
                return '-';
            }

            const labels = {
                registrado: 'Registrado',
                reactivado: 'Reactivado',
                reactivado_confirmado: 'Reactivado y confirmado',
                confirmado: 'Confirmado',
                duplicado_pendiente: 'Duplicado pendiente',
                duplicado_confirmado: 'Duplicado confirmado',
                descartado: 'Descartado',
            };

            return labels[estado] || estado;
        },
        formatTiempoRespuesta(ms) {
            const value = Number(ms || 0);
            if (!Number.isFinite(value) || value <= 0) {
                return '-';
            }

            return `${Math.round(value)} ms`;
        },
        crmEstadoTexto(estado) {
            const value = String(estado || '').trim();
            const labels = {
                enviado_ok: 'Enviado OK',
                duplicado: 'Ya existía en CRM',
                reenviado_admin_exitoso: 'Enviado OK',
                reenviado_admin_duplicado: 'Ya existía en CRM',
                reenvio_programado: 'Programado',
                en_proceso: 'En proceso',
                error_envio: 'Error',
                reenviado_admin_error: 'Error',
            };

            return labels[value] || 'Pendiente';
        },
        crmEstadoBadge(estado) {
            const value = String(estado || '').trim();
            if (['enviado_ok', 'reenviado_admin_exitoso'].includes(value)) return 'badge-success';
            if (['duplicado', 'reenviado_admin_duplicado'].includes(value)) return 'badge-warning';
            if (['error_envio', 'reenviado_admin_error'].includes(value)) return 'badge-danger';
            if (['reenvio_programado', 'en_proceso'].includes(value)) return 'badge-info';
            return 'badge-secondary';
        },
        escapeCsvValue(value) {
            const text = (value ?? '').toString();
            if (/[",\n;\r]/.test(text)) {
                return `"${text.replace(/"/g, '""')}"`;
            }
            return text;
        },
        async descargarListadoQr() {
            this.descargandoListadoQr = true;

            try {
                const res = await axios.get(`/api/get_asistentes_qr_evento/${this.eventoId}`, {
                    params: { exportar_todo: 1 },
                });
                const rows = (res.data && Array.isArray(res.data.asistentes)) ? res.data.asistentes : [];
                if (!rows.length) {
                    this.notify('info', 'No hay asistentes QR para exportar en este evento.');
                    return;
                }

                const headers = [
                    'Estado',
                    'Tipo documento',
                    'Documento',
                    'Nombre',
                    'Correo',
                    'Celular',
                    'Respuesta',
                    'Tiempo respuesta (ms)',
                    'Asistio',
                ];

                const csvRows = rows.map((item) => [
                    item?.asistio ? 'Asistio' : 'Pendiente',
                    (item?.tipo_documento || 'rut').toUpperCase(),
                    item?.documento || item?.rut || '',
                    this.nombreCompleto(item),
                    item?.email || '',
                    item?.celular || '',
                    this.formatRespuestaQr(item),
                    item?.tiempo_respuesta_ms || '',
                    this.formatFecha(item?.asistio_at || item?.escaneado_at),
                ]);

                const content = [headers, ...csvRows]
                    .map((cols) => cols.map((col) => this.escapeCsvValue(col)).join(';'))
                    .join('\n');

                const csvWithBom = `\uFEFF${content}`;
                const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const evento = (this.eventoNombre || `evento_${this.eventoId || 'qr'}`)
                    .toString()
                    .trim()
                    .replace(/\s+/g, '_')
                    .replace(/[^a-zA-Z0-9_-]/g, '');

                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `asistentes_qr_${evento}.csv`;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                URL.revokeObjectURL(url);
            } catch (error) {
                this.notify('error', error?.response?.data?.mensaje || 'No se pudo descargar el listado QR del evento.');
            } finally {
                this.descargandoListadoQr = false;
            }
        },
        notify(icon, text) {
            Swal.fire({
                icon,
                title: text,
                timer: 2200,
                showConfirmButton: false,
            });
        },
    },
};
</script>

<template>
    <div class="qr-attendance-tab">
        <div class="qr-attendance-toolbar">
            <div>
                <h5 class="mb-1">Control de asistencia por QR</h5>
                <p class="text-muted mb-0">Escanea el QR desde el celular, confirma “Asistió” y continúa de inmediato con el siguiente registro.</p>
            </div>
            <div class="qr-attendance-summary">
                <span class="badge badge-light">Confirmados: {{ asistentesConfirmados }}</span>
            </div>
        </div>

        <div v-if="puedeGestionarCrm" class="qr-crm-panel mb-3">
            <div class="qr-crm-summary">
                <div><small>Total QR</small><strong>{{ resumenAsistentes.total }}</strong></div>
                <div><small>Gestionados CRM</small><strong>{{ resumenAsistentes.crmEnviados }}</strong></div>
                <div><small>Pendientes</small><strong>{{ resumenAsistentes.crmPendientes + resumenAsistentes.crmProgramados + resumenAsistentes.crmEnProceso }}</strong></div>
                <div><small>Errores</small><strong class="text-danger">{{ resumenAsistentes.crmErrores }}</strong></div>
            </div>
            <div class="progress mt-3" style="height: 8px;">
                <div class="progress-bar" role="progressbar" :style="{ width: `${crmProgreso}%` }" :aria-valuenow="crmProgreso" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="d-flex flex-wrap justify-content-between align-items-center mt-2" style="gap: 0.75rem;">
                <span class="small text-muted">Avance: {{ crmProcesados }} de {{ resumenAsistentes.total }} ({{ crmProgreso }}%)</span>
                <b-button size="sm" variant="success" @click="enviarAsistentesQrCrm" :disabled="enviandoQrCrm || totalProgramableCrm === 0">
                    <i class="bx bx-upload mr-1"></i>
                    {{ enviandoQrCrm ? 'Agregando a la cola...' : `Enviar ${totalProgramableCrm} pendientes a CRM` }}
                </b-button>
            </div>
        </div>

        <div class="qr-public-link card border-0 shadow-sm mb-3">
            <div class="card-body">
                <div class="qr-public-link-head">
                    <div>
                        <h6 class="mb-1">Link de escaneo público</h6>
                        <p class="text-muted mb-0">Vista pública para escanear credenciales y mostrar solo los últimos 5 ingresos.</p>
                    </div>
                </div>

                <div class="qr-public-link-row mt-3">
                    <div class="qr-public-link-text">
                        <span class="text-muted small d-block">Generador de QR</span>
                        <a :href="qrGeneratorLink" target="_blank" rel="noopener noreferrer">{{ qrGeneratorLink }}</a>
                    </div>
                    <a class="btn btn-sm btn-outline-secondary" :href="qrGeneratorLink" target="_blank" rel="noopener noreferrer">
                        <i class="bx bx-link-external"></i>
                        Generador de QR
                    </a>
                </div>

                <div v-if="publicScanLinkCerrado" class="alert alert-warning mb-0 mt-3">
                    Escaneo cerrado. Los asistentes ya fueron enviados al CRM y el link público quedó deshabilitado.
                </div>
                <div v-else-if="publicScanLink" class="qr-public-link-row mt-3">
                    <div class="qr-public-link-text">
                        <span class="text-muted small d-block">Link público generado</span>
                        <a :href="publicScanLink" target="_blank" rel="noopener noreferrer">{{ publicScanLink }}</a>
                    </div>
                    <b-button size="sm" variant="primary" @click="copiarLinkEscaneoPublico" :disabled="copiandoPublicScanLink">
                        <i class="bx bx-copy"></i>
                        {{ copiandoPublicScanLink ? 'Copiando...' : 'Copiar' }}
                    </b-button>
                    <a class="btn btn-sm btn-outline-secondary" :href="publicScanLink" target="_blank" rel="noopener noreferrer">
                        <i class="bx bx-link-external"></i>
                        Abrir
                    </a>
                </div>
                <div v-else-if="!cargandoPublicScanLink" class="qr-public-link-row mt-3">
                    <span class="text-muted small">Aún no hay link público generado para este evento.</span>
                    <b-button size="sm" variant="outline-primary" @click="generarLinkEscaneoPublico" :disabled="!eventoId || publicScanLinkCerrado">
                        Generar link público
                    </b-button>
                </div>
                <p v-if="!publicScanLinkCerrado && publicScanLink && publicScanLinkVigente" class="text-muted small mb-0 mt-2">
                    Vigente hasta {{ formatFechaExpiracionLink(publicScanLinkExpiraEn) }}.
                </p>
                <p v-else-if="publicScanLink && !publicScanLinkVigente" class="text-danger small mb-0 mt-2">
                    Link vencido. El escaneo público se deshabilita en la fecha de término del evento.
                </p>
                <p v-else-if="cargandoPublicScanLink" class="text-muted small mb-0 mt-3">Buscando link público del evento...</p>
            </div>
        </div>

        <div class="qr-attendance-scanner card border-0 shadow-sm">
            <div class="card-body">
                <div class="qr-attendance-actions">
                    <b-button variant="primary" class="qr-attendance-button" @click="toggleScanner" :disabled="iniciandoScanner || !eventoId || publicScanLinkCerrado">
                        <i class="bx" :class="scannerActivo ? 'bx-stop-circle' : 'bx-camera'"></i>
                        {{ scanButtonLabel }}
                    </b-button>
                    <span v-if="scannerActivo" class="text-success small">Cámara activa. Apunta al QR del asistente.</span>
                </div>

                <div v-if="metricasRespuesta && metricasRespuesta.ok" class="alert alert-info mt-3 mb-0 py-2 px-3">
                    <strong>Última respuesta positiva:</strong>
                    Registro {{ metricasRespuesta.msRegistro }} ms |
                    Confirmación {{ metricasRespuesta.msConfirmacion }} ms |
                    Total {{ metricasRespuesta.msTotal }} ms
                </div>

                <div v-if="errorScanner" class="alert alert-warning mt-3 mb-0">{{ errorScanner }}</div>

                <div :id="readerId" class="qr-attendance-reader mt-3" :class="{ 'is-active': scannerActivo }"></div>

                <div v-if="currentScan" class="qr-current-scan mt-3">
                    <div class="qr-current-card">
                        <div class="qr-current-head">
                            <div>
                                <span class="badge" :class="currentScan.asistio ? 'badge-success' : 'badge-warning'">
                                    {{ currentScan.asistio ? 'Asistencia confirmada' : 'Lectura pendiente' }}
                                </span>
                                <h4 class="mt-2 mb-1">{{ nombreCompleto(currentScan) }}</h4>
                                <p class="mb-0 text-muted">{{ (currentScan.tipo_documento || 'rut').toUpperCase() }}: {{ currentScan.documento || currentScan.rut }}</p>
                            </div>
                        </div>

                        <div class="qr-current-grid">
                            <div>
                                <small>Correo</small>
                                <strong>{{ currentScan.email || '—' }}</strong>
                            </div>
                            <div>
                                <small>Celular</small>
                                <strong>{{ currentScan.celular || '—' }}</strong>
                            </div>
                        </div>

                        <div class="qr-current-footer">
                            <b-button
                                v-if="!currentScan.asistio"
                                variant="success"
                                class="qr-attendance-button"
                                @click="confirmarAsistencia()"
                                :disabled="guardandoAsistencia"
                            >
                                <i class="bx bx-check-circle"></i>
                                {{ guardandoAsistencia ? 'Guardando...' : 'Asistió' }}
                            </b-button>
                            <b-button
                                v-else
                                variant="outline-primary"
                                class="qr-attendance-button"
                                @click="escanearSiguiente"
                            >
                                <i class="bx bx-scan"></i>
                                Escanear siguiente
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">
                    Registros escaneados
                    <span class="text-muted small">({{ resumenAsistentes.total }} total)</span>
                </h6>
                <div class="d-flex align-items-center" style="gap: 0.5rem;">
                    <select v-if="puedeGestionarCrm" class="form-control form-control-sm" style="width: 130px;" v-model="filtroCrm" @change="cambiarFiltroCrm" :disabled="cargando || !eventoId">
                        <option value="todos">Todos CRM</option>
                        <option value="pendientes">Pendientes</option>
                        <option value="enviados">Gestionados</option>
                        <option value="errores">Con error</option>
                    </select>
                    <select class="form-control form-control-sm" style="width: 92px;" v-model.number="paginacion.perPage" @change="cambiarTamanoPagina" :disabled="cargando || !eventoId">
                        <option :value="40">40</option>
                        <option :value="80">80</option>
                        <option :value="120">120</option>
                    </select>
                    <b-button size="sm" variant="outline-primary" @click="descargarListadoQr" :disabled="cargando || descargandoListadoQr || !eventoId || !asistentes.length">
                        <b-spinner v-if="descargandoListadoQr" small class="mr-1"></b-spinner>
                        {{ descargandoListadoQr ? 'Preparando listado...' : 'Descargar listado QR' }}
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" @click="cargarAsistentes({ keepPage: true })" :disabled="cargando || !eventoId">
                        {{ cargando ? 'Actualizando...' : 'Actualizar lista' }}
                    </b-button>
                </div>
            </div>

            <div v-if="resumenAsistentes.total > 0" class="d-flex justify-content-between align-items-center mb-2 small text-muted">
                <span>Mostrando {{ paginacion.from }}-{{ paginacion.to }} de {{ resumenAsistentes.total }}</span>
                <span>Página {{ paginacion.page }} de {{ paginacion.totalPages }}</span>
            </div>

            <div v-if="!asistentes.length && !cargando" class="text-muted text-center py-4 card border-0 shadow-sm">
                Aún no hay asistentes QR registrados para este evento.
            </div>

            <div v-if="cargando" class="text-muted text-center py-4 card border-0 shadow-sm">
                Cargando asistentes QR...
            </div>

            <div v-if="asistentes.length" class="d-md-none qr-attendance-list-mobile">
                <div v-for="item in asistentes" :key="item.id" class="qr-mobile-card">
                    <div class="d-flex justify-content-between align-items-start mb-2">
                        <div>
                            <h6 class="mb-1">{{ nombreCompleto(item) }}</h6>
                            <div class="text-muted small">{{ item.documento || item.rut }}</div>
                        </div>
                        <span class="badge" :class="item.asistio ? 'badge-success' : 'badge-warning'">
                            {{ item.asistio ? 'Asistió' : 'Pendiente' }}
                        </span>
                    </div>
                    <div class="small text-muted mb-2">Asistió: {{ formatFecha(item.asistio_at || item.escaneado_at) }}</div>
                    <div v-if="puedeVerMetricasFila" class="small text-muted mb-1">Respuesta: {{ formatRespuestaQr(item) }}</div>
                    <div v-if="puedeVerMetricasFila" class="small text-muted mb-2">Tiempo: {{ formatTiempoRespuesta(item.tiempo_respuesta_ms) }}</div>
                    <div v-if="puedeGestionarCrm" class="mb-2">
                        <span class="badge" :class="crmEstadoBadge(item.estado_crm)">{{ crmEstadoTexto(item.estado_crm) }}</span>
                        <div v-if="item.ultimo_error_crm" class="small text-danger mt-1">{{ item.ultimo_error_crm }}</div>
                    </div>
                    <div class="small mb-2">{{ item.email || 'Sin correo' }}</div>
                    <div class="small mb-3">{{ item.celular || 'Sin celular' }}</div>
                    <b-button v-if="!item.asistio" size="sm" variant="success" block @click="confirmarAsistencia(item)" :disabled="guardandoAsistencia">
                        Marcar asistió
                    </b-button>
                    <b-button size="sm" variant="outline-warning" block class="mt-2" @click="eliminarAsistente(item)" :disabled="eliminandoAsistenteId === Number(item.id)">
                        {{ eliminandoAsistenteId === Number(item.id) ? 'Descartando...' : 'Descartar registro' }}
                    </b-button>
                </div>
            </div>

            <div v-if="asistentes.length" class="table-responsive d-none d-md-block card border-0 shadow-sm">
                <table class="table table-hover mb-0">
                    <thead>
                        <tr>
                            <th>Estado</th>
                            <th>Nombre</th>
                            <th>Documento</th>
                            <th>Correo</th>
                            <th>Celular</th>
                            <th v-if="puedeVerMetricasFila">Respuesta</th>
                            <th v-if="puedeVerMetricasFila">Tiempo</th>
                            <th v-if="puedeGestionarCrm">CRM</th>
                            <th>Asistió</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in asistentes" :key="item.id">
                            <td>
                                <span class="badge" :class="item.asistio ? 'badge-success' : 'badge-warning'">
                                    {{ item.asistio ? 'Asistió' : 'Pendiente' }}
                                </span>
                            </td>
                            <td>{{ nombreCompleto(item) }}</td>
                            <td>{{ item.documento || item.rut }}</td>
                            <td>{{ item.email || '-' }}</td>
                            <td>{{ item.celular || '-' }}</td>
                            <td v-if="puedeVerMetricasFila">{{ formatRespuestaQr(item) }}</td>
                            <td v-if="puedeVerMetricasFila">{{ formatTiempoRespuesta(item.tiempo_respuesta_ms) }}</td>
                            <td v-if="puedeGestionarCrm">
                                <span class="badge" :class="crmEstadoBadge(item.estado_crm)">{{ crmEstadoTexto(item.estado_crm) }}</span>
                                <div v-if="item.ultimo_error_crm" class="small text-danger mt-1 qr-crm-error" :title="item.ultimo_error_crm">{{ item.ultimo_error_crm }}</div>
                                <div v-if="item.reintentos_crm" class="small text-muted">Intentos: {{ item.reintentos_crm }}</div>
                            </td>
                            <td>{{ formatFecha(item.asistio_at || item.escaneado_at) }}</td>
                            <td>
                                <div class="qr-attendance-table-actions">
                                    <b-button v-if="!item.asistio" size="sm" variant="success" @click="confirmarAsistencia(item)" :disabled="guardandoAsistencia">
                                        Asistió
                                    </b-button>
                                    <b-button size="sm" variant="outline-warning" @click="eliminarAsistente(item)" :disabled="eliminandoAsistenteId === Number(item.id)">
                                        {{ eliminandoAsistenteId === Number(item.id) ? '...' : 'Descartar' }}
                                    </b-button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="resumenAsistentes.total > paginacion.perPage" class="d-flex justify-content-end align-items-center mt-2" style="gap: 0.5rem;">
                <b-button size="sm" variant="outline-secondary" @click="irPagina(paginacion.page - 1)" :disabled="cargando || !paginacion.hasPrev">
                    Anterior
                </b-button>
                <b-button size="sm" variant="outline-secondary" @click="irPagina(paginacion.page + 1)" :disabled="cargando || !paginacion.hasNext">
                    Siguiente
                </b-button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.qr-attendance-toolbar {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    align-items: flex-start;
    margin-bottom: 1rem;
}

.qr-attendance-summary {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.qr-crm-panel {
    border: 1px solid #d9e2ec;
    border-left: 4px solid #2f855a;
    padding: 1rem;
    background: #f8fafc;
}

.qr-crm-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(110px, 1fr));
    gap: 1rem;
}

.qr-crm-summary small,
.qr-crm-summary strong {
    display: block;
}

.qr-crm-summary strong {
    font-size: 1.25rem;
}

.qr-crm-error {
    max-width: 240px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 767px) {
    .qr-crm-summary {
        grid-template-columns: repeat(2, minmax(110px, 1fr));
    }
}

.qr-attendance-scanner {
    border-radius: 1rem;
    overflow: hidden;
}

.qr-attendance-actions {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    flex-wrap: wrap;
}

.qr-public-link {
    border-radius: 1rem;
}

.qr-public-link-head,
.qr-public-link-row {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.qr-public-link-text {
    min-width: min(100%, 360px);
    flex: 1 1 360px;
    overflow-wrap: anywhere;
}

.qr-public-link-text a {
    font-size: 0.875rem;
}

.qr-attendance-button {
    min-height: 46px;
    border-radius: 999px;
    font-weight: 700;
}

.qr-attendance-reader {
    min-height: 140px;
    border: 2px dashed #e3b48f;
    border-radius: 1rem;
    background: linear-gradient(180deg, #fff8f3 0%, #fff 100%);
    padding: 0.75rem;
}

.qr-attendance-reader.is-active {
    min-height: 320px;
    border-style: solid;
    border-color: rgba(37, 44, 95, 0.08);
    background: #10131c;
    padding: 0;
}

.qr-attendance-reader.is-active:deep(video) {
    border-radius: 0.9rem;
}

.qr-attendance-reader.is-active:deep(#qr-shaded-region) {
    border-width: 0 !important;
}

.qr-attendance-reader.is-active:deep(#qr-shaded-region > div) {
    border-color: #ffffff !important;
    border-width: 8px !important;
}

.qr-attendance-reader.is-active:deep(img),
.qr-attendance-reader.is-active:deep(video),
.qr-attendance-reader.is-active:deep(canvas) {
    display: block;
    width: 100% !important;
}

.qr-attendance-reader.is-active:deep(#html5-qrcode-anchor-scan-type-change) {
    display: none !important;
}

.qr-current-card {
    border-radius: 1rem;
    padding: 1rem;
    background: linear-gradient(180deg, #fff8f3 0%, #fff 100%);
    border: 1px solid rgba(201, 126, 55, 0.22);
}

.qr-current-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    margin-top: 1rem;
}

.qr-current-grid small {
    display: block;
    color: #7b7b7b;
    margin-bottom: 0.2rem;
}

.qr-current-footer {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
}

.qr-manual-test {
    border-top: 1px solid rgba(201, 126, 55, 0.18);
    padding-top: 1rem;
}

.qr-manual-test__label {
    display: block;
    font-weight: 700;
    margin-bottom: 0.2rem;
}

.qr-manual-test__actions {
    display: flex;
    justify-content: flex-end;
}

.qr-attendance-list-mobile {
    display: grid;
    gap: 0.75rem;
}

.qr-mobile-card {
    border-radius: 1rem;
    padding: 1rem;
    background: #fff;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
}

.qr-attendance-table-actions {
    display: flex;
    gap: 0.45rem;
    align-items: center;
}

@media (max-width: 767px) {
    .qr-attendance-toolbar {
        flex-direction: column;
    }

    .qr-attendance-reader {
        padding: 0.5rem;
    }

    .qr-attendance-reader.is-active {
        min-height: 280px;
        border: 0;
        border-radius: 1rem;
        overflow: hidden;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
    }

    .qr-current-grid {
        grid-template-columns: 1fr;
    }

    .qr-current-footer {
        justify-content: stretch;
    }

    .qr-current-footer .btn {
        width: 100%;
    }

    .qr-manual-test__actions {
        justify-content: stretch;
    }

    .qr-manual-test__actions .btn {
        width: 100%;
    }
}
</style>
